import React from 'react'
import Video from '../video/Video'
import { browserHistory } from 'react-router'

const VideoPageContent = (props) => {
	const { video } = props;
		return (
      <main className="main " >
				<div className="page mt3 mb8">
					<a className="link" onClick={browserHistory.goBack}>Back</a>
					<h5>{video.name}</h5>
					<Video key={`video-${video._id}`} video={video} />

					<p>
						{video.description}
					</p>
				</div>
			</main>)
}

export default VideoPageContent;



// WEBPACK FOOTER //
// ./src/components/home/VideoPageContent.jsx